module.exports = __webpack_public_path__ + "img/EG.9e921a25.png";